import { render, staticRenderFns } from "./PortalRegisterListFromPropertyComponent.vue?vue&type=template&id=6c644a80"
import script from "./PortalRegisterListFromPropertyComponent.vue?vue&type=script&lang=js"
export * from "./PortalRegisterListFromPropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports